module.exports = __webpack_public_path__ + "img/IMG BARES.0bc9952e.jpg";